import axios from "axios";

export const state = {
    save_status: false,
    user_performance: [],
    product_performance: [],

};

export const getters = {
    SaveStatus: state => state.save_status,
    ProductPerformance: state => state.product_performance,
    UserPerformance: state => state.user_performance,
};

export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_USERPERFORMANCE(state, newValue) {
        state.user_performance = newValue
    },

    SET_PRODUCTPERFORMANCE(state, newValue) {
        state.product_performance = newValue
    },
};
export const actions = {

    // get user performance
    fetchUserPerformance({ commit }, data) {
        axios.post('user_performance', data).then(res => {
            commit('SET_USERPERFORMANCE', res.data)
        })
    },

    // get product performance
    fetchProductPerformance({ commit }, data) {
        axios.post('product_performance', data).then(res => {
            commit('SET_PRODUCTPERFORMANCE', res.data)
        })
    },

};